import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../util/withRouter';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import { Card, IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../component/form/Grid';
import PhotoModal from '../../component/form/PhotoModal';
import Paper from '@mui/material/Paper';
import Spinner from '../../component/form/v2/Spinner';
import Typography from '../../component/Typography';
import BiggerMessageBar from '../../component/BiggerMessageBar';
import Table, { TableCell, TableHeaderCell, TableHeaderRow, TableRow } from '../../component/form/Table';
import PrimaryButton, { OutlineButton, SaveButton } from '../../component/form/PrimaryButton';
import DataFormView from '../../component/form/v2/DataFormView';
import cx from 'classnames';
import {
    acknowledgeChanges,
    getDressingStatus,
    listMortuaryChanges,
    MortuaryItemFragment,
    releaseToCheckout,
    removeValuablesItemsAction
} from './MortuaryItemConstants';
import { isNullOrUndefined } from '../../util/objects';
import ColumnLayout from '../../component/ColumnLayout';
import { flattenBookingItems, PreloadProducts, ProductConfig, QueryKeys } from '../../util/products';
import { ImageList, ImageListItem } from '../../component/form/ImageList';
import CoffinModal from './Common/CoffinModal';
import { joinDefined, prettyDisposal, stringIsNullOrEmpty } from '../../util/strings';
import ValuablesForm from './Common/ValuablesForm';
import IdentificationForm from './Common/IdentificationForm';
import history from '../../History';
import moment from 'moment';
import { InlineField, InlineFieldRightAlignChildren } from '../../component/form/Inline';
import { isContactDefined } from '../../util/bookable';
import GatedComponent from '../../component/GatedComponent';
import { niceDateTimeFromString } from '../../util/date';
import {
    getRequiredDocuments,
    getSignedArrangementFormForDocument
} from '../funeral/certification/CertificationConstants';
import LinkButton from '../../component/form/LinkButton';
import RecordDrawer from '../workQueue2/RecordDrawer';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../component/ErrorFallback';
import {
    BackIcon,
    CloseIcon,
    DeleteIcon,
    DiamondIcon,
    EditIcon,
    ExclamationCircleIcon,
    ExclamationTriangleIcon,
    MortuaryIcon,
    NextIcon,
    TickCircleIcon,
    TickIcon
} from '../../component/IconIndex';
import { indexOf } from '../../util/arrays';
import SimpleValuableDetailsModal from './Common/SimpleValuableDetailsModal';
import { isRelatedObjectUndefined } from '../../util/graphql';
import Checkbox from '../../component/form/Checkbox';
import AlertModal from '../workQueue2/extras/AlertModal';
import { getUser } from '../../util/sessions';
import { VALUABLES_LOCATION_OPTIONS } from '../funeral/details/valuables-modal/ValuablesConstants';

class MortuaryItem extends Component {
    state = {
        loading: false,
        loadingProducts: true,
        openCoffinModal: false,
        canScanCoffinCode: true,
        openValuableModal: false,
        deleteValuableModal: false,
        valuableItemId: null,
        selectedPhoto: null
    };
    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        const { form } = this.props;
        const coffinProducts = form.getState('Disposal.DisposalBookingItems') || [];
        const flowerProducts = form.getState('Florists').map(e => e.BookingItems || []) || [];

        const products = coffinProducts.concat(
            flowerProducts.length > 0 ? flowerProducts.reduce((a, b) => a.concat(b)) : []
        );

        if (products && products.length > 0) {
            PreloadProducts(this, products).then(() => this._isMounted && this.setState({ loadingProducts: false }));
        } else {
            this.setState({ loadingProducts: false });
        }
    }

    render() {
        const { classes, form } = this.props;
        const {
            selectedPhoto,
            deleteValuableModal,
            openValuableModal,
            valuableItemId,
            openCoffinModal,
            loading
        } = this.state;
        const currentValuables = form.getField('ValuableItems') || [];
        const currentItem = currentValuables.find(obj => obj.ID === valuableItemId);
        return (
            <Grid container>
                <Grid item xs={12}>
                    <InlineFieldRightAlignChildren lineHeight={'inherit'}>
                        {form.getField('Cancelled') && (
                            <BiggerMessageBar messageType="error">This record is cancelled.</BiggerMessageBar>
                        )}
                        <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                            <span>Mortuary {form.getState('LegacyKey')}</span>
                            <small className={classes.header}>
                                {`${joinDefined(
                                    [form.getState('FirstName'), form.getState('MiddleName'), form.getState('Surname')],
                                    ' '
                                )}`}
                            </small>
                        </Typography>
                        <div style={{ marginBottom: 6 }}>
                            <InlineField style={{ alignItems: 'end' }}>
                                <PrimaryButton onClick={this.backButtonFunction}>
                                    <BackIcon /> Back
                                </PrimaryButton>

                                <OutlineButton
                                    target="_blank"
                                    onClick={() =>
                                        this.viewFuneralDetails(form.getState('ID'), form.getState('LegacyKey'))
                                    }
                                >
                                    View Funeral Record
                                </OutlineButton>
                                <RecordDrawer funeralId={form.getField('ID')} legacyKey={form.getField('LegacyKey')} />
                            </InlineField>
                        </div>
                    </InlineFieldRightAlignChildren>
                </Grid>

                <Paper
                    className={cx(classes.paper, classes.bodyPadding)}
                    elevation={0}
                    style={{ position: 'relative' }}
                >
                    {!!loading && this.renderLoading()}
                    <ColumnLayout>
                        {this.renderLeftColumn()}
                        {this.renderRightColumn()}
                    </ColumnLayout>
                </Paper>

                <SimpleValuableDetailsModal
                    open={openValuableModal}
                    onClose={() => this.setState({ openValuableModal: false, valuableItemId: null })}
                    context={this}
                    itemId={valuableItemId}
                    parentId={form.getState('ID')}
                    onCreateNew={this.onSaveValuable}
                    onSaved={this.onSaveValuable}
                />

                <CoffinModal
                    context={this}
                    itemId={form.getState('ID')}
                    open={openCoffinModal}
                    onClose={() => this.setState({ openCoffinModal: false })}
                    onSaved={funeral => this.onChangeCoffin(funeral)}
                />

                <PhotoModal photo={selectedPhoto} onClose={() => this.setState({ selectedPhoto: null })} />

                {currentItem && (
                    <AlertModal
                        variant="warning"
                        open={deleteValuableModal}
                        title="Prompt - Delete Valuables Item"
                        secondaryAction={loading ? 'Deleting...' : 'Oh yeah, delete this item'}
                        onClickSecondaryAction={loading ? undefined : this.handleDeleteValuable}
                        primaryAction="Nah, keep it"
                        onClickPrimaryAction={() => this.setState({ deleteValuableModal: false, valuableItemId: null })}
                        onClose={() => this.setState({ deleteValuableModal: false, valuableItemId: null })}
                    >
                        <p>Woah there {getUser().FirstName}! Looks like you're removing a valuables item.</p>
                        <p>
                            Do you really want to delete <strong>{currentItem.Description}</strong>?
                        </p>
                    </AlertModal>
                )}
            </Grid>
        );
    }

    renderLeftColumn() {
        const { classes } = this.props;

        return (
            <Grid container spacing={3} className={classes.column} style={{ position: 'relative' }}>
                {this.renderReleaseList()}

                {this.renderChangeList()}

                {this.renderTopTextFields()}

                {this.renderPhotos()}

                {this.renderFlorists()}
            </Grid>
        );
    }

    renderRightColumn() {
        const { classes, form } = this.props;
        const { loading } = this.state;
        const isReady = form.getField('ReadyForMortuary');
        const isComplete = form.getField('DatetimeOfMortuaryCheckout');
        const isReleased = form.getField('DatetimeReadyForMortuaryCheckout');

        const missing = this.getMissingList();
        const msgNotReady = !!missing.length && (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <BiggerMessageBar messageType="error">
                        Not Ready for Checkout, because:
                        <ul style={{ margin: 0 }}>
                            {missing.map((e, i) => (
                                <li key={i}>
                                    <strong>{e}</strong>
                                </li>
                            ))}
                        </ul>
                    </BiggerMessageBar>
                </Grid>
            </Grid>
        );

        return (
            <Grid container spacing={3} className={classes.column} style={{ position: 'relative' }}>
                {this.renderStaff()}

                {this.renderCoffinDetails()}

                {this.renderValuablesTable()}

                {this.renderRequiredDocuments()}

                <Grid bucket>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>Release to Mortuary Checkout</span>
                        </Typography>
                        {!!isReleased ? (
                            <Typography variant="subtitle1">
                                Released: {niceDateTimeFromString(isReleased)}
                                {!!isComplete && <div>Checkout completed: {niceDateTimeFromString(isComplete)}</div>}
                            </Typography>
                        ) : (
                            msgNotReady || (
                                <Typography variant="subtitle1">Waiting for Mortuary staff to release.</Typography>
                            )
                        )}
                    </Grid>
                    <InlineField>
                        <IdentificationForm form={form} />
                        {(!isReleased && (
                            <GatedComponent showComponentCode={'FM_ACCESS_Mortuary_Process'}>
                                {() => (
                                    <SaveButton
                                        disabled={loading || !isReady || !!msgNotReady}
                                        onClick={() => this.handleReleaseToCheckout()}
                                    >
                                        <MortuaryIcon />
                                        Release to checkout
                                    </SaveButton>
                                )}
                            </GatedComponent>
                        )) || (
                            <OutlineButton onClick={e => this.goCheckoutFunction()}>
                                <NextIcon /> Go to Checkout
                            </OutlineButton>
                        )}
                    </InlineField>
                </Grid>
            </Grid>
        );
    }

    renderLoading() {
        return (
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    background: '#FFFFFF99',
                    margin: -24,
                    zIndex: 9
                }}
            >
                {this.renderLoadingWidget()}
            </div>
        );
    }

    renderLoadingWidget() {
        return (
            <div>
                <Spinner />
                &nbsp;<span>Loading...</span>
            </div>
        );
    }

    renderPhotos() {
        const { form, classes } = this.props;
        const photos = form.getField('DeceasedPhotos') || [];
        const refPhoto = form.getField('ReferencePhoto') || [];
        const refPhotoID = refPhoto && refPhoto.ID;
        return (
            <Grid bucket={true} container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        <span>Reference Photos</span>
                    </Typography>

                    {photos.length > 0 ? (
                        <ImageList>
                            {photos.map(
                                (photo, i) =>
                                    refPhotoID === photo.ID && (
                                        <ImageListItem
                                            key={i}
                                            title={'Mortuary Reference Photo'}
                                            value={{
                                                image: photo.AbsoluteLink,
                                                label: photo.Name,
                                                tileWidth: 2,
                                                tileHeight: 2
                                            }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                        />
                                    )
                            )}
                            {photos.map(
                                (photo, i) =>
                                    refPhotoID !== photo.ID && (
                                        <ImageListItem
                                            key={i}
                                            value={{
                                                image: photo.AbsoluteLink,
                                                label: photo.Name
                                            }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                        />
                                    )
                            )}
                        </ImageList>
                    ) : (
                        <Typography variant="subtitle1">No photos supplied.</Typography>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderValuablesTable() {
        const { classes, form } = this.props;
        const valuables = form.getState('ValuableItems') || [];
        const columnLabels = ['Status', 'Description', 'QTY', 'Final Action', 'Signed', 'Current Location', ''];

        const changes = this.getChangelist();
        const valuablesChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'valuables');
        const isReleased = !!form.getField('DatetimeReadyForMortuaryCheckout');

        const tableRows = isEnabled =>
            valuables.map((valuable, index) => {
                const finalAction = valuable.FinalAction || (!!valuable.ToBeReturned && 'Return') || 'Unsure';
                const isDone =
                    ('Returned' === valuable.CurrentLocation && 'Return' === finalAction) ||
                    ('Placed' === valuable.CurrentLocation && 'Remain' === finalAction);
                return (
                    <TableRow
                        key={index}
                        onClick={isEnabled ? e => this.viewValuableItem(e, valuable.ID) : null}
                        className={isEnabled ? classes.clickThis : null}
                    >
                        <TableCell dataLabel={columnLabels[0]} centred tiny>
                            {isDone ? (
                                <TickCircleIcon className={classes.good} title="Item is actioned" />
                            ) : (
                                <ExclamationTriangleIcon className={classes.warning} title="Item is not actioned" />
                            )}
                        </TableCell>
                        <TableCell dataLabel={columnLabels[1]}>
                            {valuable.Description}
                            <br />
                            <small>{valuable.Note}</small>
                        </TableCell>
                        <TableCell dataLabel={columnLabels[2]}>x{valuable.Quantity}</TableCell>
                        <TableCell dataLabel={columnLabels[3]}>{finalAction}</TableCell>
                        <TableCell dataLabel={columnLabels[4]} centred tiny>
                            {valuable.Signed ? <TickIcon color={'primary'} /> : <CloseIcon color={'disabled'} />}
                        </TableCell>
                        <TableCell dataLabel={columnLabels[5]}>
                            {
                                (
                                    VALUABLES_LOCATION_OPTIONS.find(o => o.value === valuable.CurrentLocation) || {
                                        label: 'Missing'
                                    }
                                ).label
                            }
                            <br />
                            <small>{valuable.CurrentLocationDetail}</small>
                        </TableCell>
                        <TableCell dataLabel={columnLabels[6]} pad={false} centred tiny className={classes.actions}>
                            <div>
                                <IconButton
                                    title={'Edit'}
                                    onClick={isEnabled ? e => this.viewValuableItem(e, valuable.ID) : null}
                                >
                                    <EditIcon />
                                </IconButton>
                                <IconButton
                                    title={!!valuable.Signed ? 'Cannot remove signed item' : 'Remove Unsigned Item'}
                                    disabled={!!valuable.Signed}
                                    onClick={isEnabled ? e => this.removeValuableItem(e, valuable.ID) : null}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        </TableCell>
                    </TableRow>
                );
            });

        return (
            <GatedComponent
                showComponentCode={'FM_ACCESS_Mortuary_Valuables_View'}
                isEnabledCode={'FM_ACCESS_Mortuary_Valuables_Edit'}
            >
                {isEnabled => {
                    return (
                        <Grid bucket={true} xs={12}>
                            <Grid item xs={12}>
                                <Typography variant="headline" gutterBottom className={cx(classes.pageTitle)}>
                                    Valuables
                                </Typography>

                                <div className={classes.tableData}>
                                    {valuables.length > 0 ? (
                                        <Table>
                                            <TableHeaderRow>
                                                {columnLabels.map(label => (
                                                    <TableHeaderCell>{label}</TableHeaderCell>
                                                ))}
                                            </TableHeaderRow>
                                            {tableRows(isEnabled)}
                                        </Table>
                                    ) : (
                                        <Typography variant="subtitle1">
                                            Deceased has no record of valuables.
                                        </Typography>
                                    )}
                                </div>
                                {!!valuablesChanged && (
                                    <BiggerMessageBar messageType="approve">
                                        <strong>Changed: </strong>
                                        {valuablesChanged.oldVal}
                                    </BiggerMessageBar>
                                )}
                            </Grid>
                            <InlineField>
                                <PrimaryButton
                                    disabled={!isEnabled || !!isReleased}
                                    onClick={e => this.viewValuableItem(e, null)}
                                >
                                    <DiamondIcon />
                                    Add Valuables...
                                </PrimaryButton>
                                <ValuablesForm form={form} />
                            </InlineField>
                        </Grid>
                    );
                }}
            </GatedComponent>
        );
    }

    renderCoffinDetails() {
        const { loadingProducts } = this.state;
        const changes = this.getChangelist();
        const { form, classes } = this.props;
        const coffinProducts = (form.getField('Disposal.DisposalBookingItems') || [])
            .map(b => {
                const obj = structuredClone(b);
                const hasProduct = ProductConfig.productMap[obj.ProductID];
                const product = structuredClone(hasProduct ?? { variations: [] });
                if (!!hasProduct) {
                    if (obj.Quantity && hasProduct.urlSegment === 'coffins') {
                        product.tileWidth = 2;
                        product.tileHeight = 2;
                    }
                    obj.titleObj = product.variations?.find(e => e.id === obj.VariationID) || product;
                }
                return { ...obj, product };
            })
            .sort((a, b) => (a.product?.urlSegment === 'coffins' ? -1 : 1));
        const isCoffinAssigned = coffinProducts.filter(x => x.URLSegment === QueryKeys.Coffins).length > 0;
        const isCoffinReady = form.getField('Disposal.IsCoffinPrepared');
        const isComplete = form.getField('DatetimeOfMortuaryCheckout');
        const isReleased = form.getField('DatetimeReadyForMortuaryCheckout');
        const canScanCoffinCode = !isCoffinReady && !(isComplete || isReleased) && isCoffinAssigned;
        const coffinsChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'coffins');
        return (
            <Grid container bucket={true}>
                <Grid item xs={12}>
                    <Typography
                        variant="headline"
                        gutterBottom
                        className={cx(classes.pageTitle, classes.coffinDetailsHeader)}
                    >
                        <span>Coffin Details</span>
                    </Typography>
                    <Checkbox
                        form={form}
                        name="Disposal.IsCoffinPrepared"
                        label="Coffin is trimmed and ready"
                        disabled={!isCoffinAssigned || isReleased}
                    />
                    {loadingProducts ? (
                        this.renderLoadingWidget()
                    ) : coffinProducts.length > 0 ? (
                        <Fragment>
                            <ImageList>
                                {coffinProducts.map(
                                    (obj, i) =>
                                        2 === (obj.product && obj.product.tileWidth) && (
                                            <ImageListItem key={i} value={obj.product} quantity={obj.Quantity} />
                                        )
                                )}
                                {coffinProducts.map(
                                    (obj, i) =>
                                        2 !== (obj.product && obj.product.tileWidth) && (
                                            <ImageListItem key={i} value={obj.product} quantity={obj.Quantity} />
                                        )
                                )}
                            </ImageList>
                            <ul style={{ marginBottom: 0 }}>
                                {coffinProducts.map((obj, i) => {
                                    return (
                                        <li key={i} className={Number(obj.Quantity) === 0 ? classes.strikeout : ''}>
                                            {Number(obj.Quantity) === 0 ? '' : 'x' + Number(obj.Quantity)}{' '}
                                            {obj.titleObj ? (
                                                <>
                                                    <strong>{obj.titleObj.internalId}</strong>: {obj.titleObj.title}
                                                </>
                                            ) : (
                                                'Unknown coffin'
                                            )}
                                            {1 === 2 && !!obj.Returns ? ' | To be returned' : ''}
                                            {!!obj.Comment ? ' | Comment: ' + obj.Comment : ''}
                                        </li>
                                    );
                                })}
                            </ul>
                        </Fragment>
                    ) : (
                        <BiggerMessageBar messageType="error">No coffin has been selected.</BiggerMessageBar>
                    )}

                    {!!coffinsChanged && (
                        <BiggerMessageBar messageType="approve">
                            <strong>Changed:</strong> {coffinsChanged.oldVal}
                        </BiggerMessageBar>
                    )}
                </Grid>
                <GatedComponent showComponentCode={'FM_ACCESS_Mortuary_Process'}>
                    {() => {
                        return (
                            <Grid item xs={12}>
                                <PrimaryButton
                                    onClick={() => this.setState({ openCoffinModal: true })}
                                    disabled={!canScanCoffinCode}
                                >
                                    Scan Coffin Barcode...
                                </PrimaryButton>
                            </Grid>
                        );
                    }}
                </GatedComponent>
            </Grid>
        );
    }

    renderTopTextFields() {
        const { form, classes } = this.props;
        const changes = this.getChangelist();

        let latestDate = moment().add(100, 'years');
        let viewing = null;
        const items = form.getState('PlaceOfViewingItems') || [];
        items.forEach(e => {
            const theDate = moment(e.Start || e.Date);
            if (moment(theDate).isValid() && theDate < latestDate) {
                latestDate = theDate;
                viewing = e;
            }
        });
        const isGraveside = form.getField('PlaceOfService.Type') === 'Graveside';
        const service = !!isGraveside ? form.getState('Disposal') : form.getState('PlaceOfService');
        const getRelease = () => {
            const startV = !!viewing && (viewing.Start || viewing.Date);
            const startS = !!service && (service.Start || service.Date);
            if (startV && !startS) return viewing;
            if (startS && !startV) return service;
            return moment(startV).isBefore(startS) ? viewing : service;
        };
        const release = getRelease();
        const isCremation = form.getState('Disposal.CrematedOrBuried') === 'Cremated';
        const hasPacemaker = !!isCremation && !!form.getState('RemovePacemaker');
        const yetToRemovePacemaker = !!hasPacemaker && !!form.getState('RemovePacemakerPending');
        const needsReferee = !!isCremation && !(form.getState('Certification.TypeOfBdmDeathCertificate') === 'Coroner');
        const isCrypt =
            (form.getState('Disposal.CrematedOrBuried') === 'Buried' ||
                form.getState('Disposal.CrematedOrBuried') === 'Repatriated') &&
            (form.getState('Grave.GroundDescription') === 'Crypt' || form.getState('Grave.DepthOption') === 'Crypt');
        const pacemakerDone = !form.getState('RemovePacemakerPending');
        const isReleased = form.getField('DatetimeReadyForMortuaryCheckout');
        const dressingStatus = getDressingStatus(form);

        const serviceChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'service');
        const viewingChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'viewing');
        const releaseChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'release');
        const dressingChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'dressing');
        const batteryChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'pacemaker');
        const genderChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'gender');
        const surnameChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'surname');
        const firstnameChanged = !!changes && changes.length !== 0 && changes.find(e => e.field === 'firstname');
        return (
            <Fragment>
                <Grid container bucket={true}>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            {prettyDisposal(form.getState('Disposal.CrematedOrBuried'), false)}
                            {!!isCremation && (
                                <span className={classes.lightGreyHeader}>
                                    {!!needsReferee ? (
                                        !!isContactDefined(form.getState('Certification.Referee')) ? (
                                            !!form.getState('RefereeCremationCheck') ? (
                                                <Fragment>
                                                    Referee Completed{' '}
                                                    <TickIcon className={classes.icon} title={'Completed'} />
                                                </Fragment>
                                            ) : (
                                                <span className={classes.warning}>Referee In Progress</span>
                                            )
                                        ) : (
                                            <span className={classes.warning}>Referee NOT ASSIGNED</span>
                                        )
                                    ) : (
                                        'Referee Not Required'
                                    )}
                                </span>
                            )}
                            {!!isCrypt && <span className={classes.lightGreyHeader}>for Crypt</span>}
                        </Typography>

                        <Typography variant="subtitle1">
                            Accommodation:{' '}
                            <span className={classes.purpleText}>
                                {!!form.getField('MortuaryLocation.Name')
                                    ? form.getField('MortuaryLocation.Name')
                                    : '(inbound)'}
                            </span>
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            First Name: <strong>{form.getField('FirstName')}</strong>
                            <br />
                            Surname: <strong>{form.getField('Surname')}</strong>
                            <br />
                            Gender: <strong>{form.getField('Gender')}</strong>
                        </Typography>
                        {(!!genderChanged || !form.getField('Gender')) &&
                            this.renderChangeItem(genderChanged, 'Gender')}
                        {(!!surnameChanged || !form.getField('Surname')) &&
                            this.renderChangeItem(surnameChanged, 'Surname')}
                        {(!!firstnameChanged || !form.getField('FirstName')) &&
                            this.renderChangeItem(firstnameChanged, 'First Name')}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            Viewing:{' '}
                            <span className={classes.purpleText}>
                                {!!form.getField('PlaceOfViewingRequired') && !isNullOrUndefined(viewing)
                                    ? !!viewing.Date && !!viewing.Time
                                        ? niceDateTimeFromString(viewing.Date + ' ' + viewing.Time)
                                        : 'Date/time not provided.'
                                    : 'No viewings.'}
                            </span>
                        </Typography>
                        {!!viewingChanged && this.renderChangeItem(viewingChanged)}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            Service:{' '}
                            <span className={classes.purpleText}>
                                {!isNullOrUndefined(service) && service.Type !== 'No Service No Attendance'
                                    ? !!service.Date && !!service.Time
                                        ? niceDateTimeFromString(service.Date + ' ' + service.Time)
                                        : 'Date/time not provided.'
                                    : 'No service.'}
                            </span>
                        </Typography>
                        {!!serviceChanged && this.renderChangeItem(serviceChanged)}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            Release to:{' '}
                            <span className={classes.purpleText}>
                                {!isNullOrUndefined(release) && !!isContactDefined(release.Location)
                                    ? release.LocationFlattened
                                    : 'No release specified.'}
                            </span>
                        </Typography>
                        {!!releaseChanged && this.renderChangeItem(releaseChanged)}
                        {!isNullOrUndefined(release) &&
                            !isNullOrUndefined(release.Comment) &&
                            !!release.Comment.trim() && (
                                <Typography variant="subtitle1">
                                    Comments: <i>{release.Comment}</i>
                                </Typography>
                            )}
                    </Grid>
                </Grid>

                <Grid bucket={true}>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>Dressing</span>
                        </Typography>

                        {'No dressing has been selected.' === dressingStatus ? (
                            <BiggerMessageBar messageType="error">{dressingStatus}</BiggerMessageBar>
                        ) : (
                            <Typography variant="subtitle1">{dressingStatus}</Typography>
                        )}
                        {!!dressingChanged && this.renderChangeItem(dressingChanged, 'Dressing')}
                    </Grid>
                </Grid>

                <Grid bucket={true}>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>Preparation Notes</span>
                        </Typography>

                        {form.getState('IsBariatric') && (
                            <BiggerMessageBar messageType="warning">
                                <strong>Bariatric</strong>. Follow safe lifting techniques and get assistance.
                            </BiggerMessageBar>
                        )}
                        {form.getState('IsInfectious') && (
                            <BiggerMessageBar messageType="warning">
                                <strong>Infectious</strong>. Follow infection control protocols and use protective gear.
                            </BiggerMessageBar>
                        )}
                        {form.getState('IsDecomposed') && (
                            <BiggerMessageBar messageType="warning">
                                <strong>Decomposed</strong>. Take precautions when handling or exposing.
                            </BiggerMessageBar>
                        )}

                        <Typography variant="subtitle1" className={classes.notesPre}>
                            {form.getState('CoffinComment') || 'No additional notes.'}
                        </Typography>

                        {!!isCrypt && (
                            <BiggerMessageBar messageType="info">Embalming is required for Crypt.</BiggerMessageBar>
                        )}

                        {!!hasPacemaker &&
                            (!!yetToRemovePacemaker ? (
                                <BiggerMessageBar messageType="error">
                                    Pacemaker must be removed for cremation.
                                </BiggerMessageBar>
                            ) : (
                                !!isReleased && (
                                    <BiggerMessageBar messageType="info">Pacemaker marked as removed.</BiggerMessageBar>
                                )
                            ))}

                        {!!isCremation && !isReleased && (
                            <InlineField>
                                <Checkbox
                                    label="Internal Pacemaker/CIED"
                                    form={form}
                                    name="RemovePacemaker"
                                    onChange={(evt, val) => {
                                        form.setField({ RemovePacemakerPending: !!val });
                                    }}
                                />
                                {!!hasPacemaker && (
                                    <Checkbox
                                        label="Pacemaker is removed"
                                        checked={pacemakerDone}
                                        onChange={(evt, val) => {
                                            form.setField({ RemovePacemakerPending: !val });
                                        }}
                                    />
                                )}
                            </InlineField>
                        )}

                        {!!batteryChanged && this.renderChangeItem(batteryChanged)}
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    renderStaff() {
        const { form, classes } = this.props;
        const renderStaffList = staffType =>
            form
                .getField(staffType)
                .filter(e => !isRelatedObjectUndefined(e.Member))
                .map((e, i, a) => {
                    return (
                        <span key={i}>
                            <span className={classes.purpleText}>
                                {joinDefined([e.Member.FirstName, e.Member.Surname], ' ')}
                            </span>
                            {1 + i === a.length ? '.' : ', '}
                        </span>
                    );
                });
        const listArrangers = renderStaffList('Arrangers');
        const listCoordinators = renderStaffList('Coordinators');
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        Funeral Staff
                    </Typography>
                    <Typography variant="subtitle1">
                        <span>Arrangers: </span>
                        {listArrangers.length ? listArrangers : ' none assigned.'}
                    </Typography>
                    <Typography variant="subtitle1">
                        <span>Coordinators: </span>
                        {listCoordinators.length ? listCoordinators : ' none assigned.'}
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    renderChangeItem(changeItem, thing = 'data') {
        return (
            <BiggerMessageBar messageType="approve">
                {(!!changeItem && changeItem.oldVal && (
                    <Fragment>
                        <>{changeItem.message}</>
                        <>
                            <br />
                            Was: {changeItem.oldVal ? <del>{changeItem.oldVal}</del> : <i>(empty)</i>}
                        </>
                    </Fragment>
                )) || (
                    <>
                        There was no value set{' '}
                        {thing !== 'data' ? (
                            <>
                                {' '}
                                for <strong>{thing}</strong>
                            </>
                        ) : (
                            ''
                        )}
                    </>
                )}
            </BiggerMessageBar>
        );
    }

    renderReleaseList() {
        const { form } = this.props;
        if (!!form.getField('DatetimeReadyForMortuaryCheckout')) {
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <BiggerMessageBar>This record was released to Mortuary Checkout.</BiggerMessageBar>
                    </Grid>
                </Grid>
            );
        }
        return null;
    }

    renderChangeList() {
        const { form, classes } = this.props;
        const { loading } = this.state;
        if (!!form.getField('DatetimeReadyForMortuaryCheckout')) return null;
        const isReturned = form.getField('MortuaryActionReturnedReason');
        const changes = this.getChangelist();
        return !(!changes || changes.length === 0) || isReturned ? (
            <Grid container bucket>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        <span>For Review</span>
                    </Typography>

                    {!!isReturned && <BiggerMessageBar messageType="error">{isReturned}</BiggerMessageBar>}
                    {!!changes.length && (
                        <BiggerMessageBar messageType="approve">
                            Details have changed, please review:
                            <ol style={{ margin: 0 }}>
                                {changes.map((e, i) => (
                                    <li key={i}>
                                        <strong>{e.message}</strong>
                                    </li>
                                ))}
                            </ol>
                        </BiggerMessageBar>
                    )}
                    <SaveButton disabled={loading} onClick={this.handleAcknowledgement}>
                        <TickCircleIcon />
                        Acknowledge & Clear
                    </SaveButton>
                </Grid>
            </Grid>
        ) : null;
    }

    getChangelist() {
        const { form } = this.props;
        if (form.getField('DatetimeReadyForMortuaryCheckout')) return [];
        if (!form.getField('MortuaryWatchChanged')) return [];
        return listMortuaryChanges(form);
    }

    getMissingList() {
        const missingList = [];
        const { form } = this.props;
        if (form.getField('DatetimeReadyForMortuaryCheckout')) return missingList;

        /* check personal/body details */
        if (!form.getField('Surname')) {
            missingList.push('Surname is missing.');
        }
        if (!form.getField('FirstName')) {
            missingList.push('First Name is missing.');
        }
        if (!form.getField('Gender')) {
            missingList.push('Gender is missing.');
        }

        /* check dates assigned */
        // if (!form.getField('DateOfService')) {
        //     missingList.push('Funeral Date is missing.');
        // }

        /* check preparation requirements */
        if (!form.getField('FuneralDressing.Status') && !form.getField('FuneralDressing.Shroud')) {
            missingList.push('Dressing notes are missing.');
        }
        const coffinBits = form.getField('Disposal.DisposalBookingItems');
        if (!(coffinBits && coffinBits.find(bit => 'coffins' === bit.URLSegment && 1 === bit.Quantity))) {
            missingList.push('Coffin is missing.');
        }

        /* check certification requirements */
        const isCremation = form.getState('Disposal.CrematedOrBuried') === 'Cremated';
        // const needsReferee = !!isCremation && !(form.getState('Certification.TypeOfBdmDeathCertificate') === 'Coroner');
        // if (!!needsReferee) {
        //     if (!form.getState('RefereeCremationCheck')) {
        //         missingList.push('Referee Documents are missing.');
        //     }
        //     if (!isContactDefined(form.getState('Certification.Referee'))) {
        //         missingList.push('Referee Doctor is not assigned.');
        //     }
        // }
        const hasPacemaker = !!isCremation && !!form.getState('RemovePacemaker');
        const yetToRemovePacemaker = !!hasPacemaker && !!form.getState('RemovePacemakerPending');
        if (!!yetToRemovePacemaker) {
            missingList.push('Pacemaker has not been removed.');
        }
        if (form.isDirty) {
            missingList.push('Unsaved changes.');
        }

        return missingList;
    }

    renderFlorists() {
        const { form, classes } = this.props;
        const florists = form.getField('Florists') || [];
        return (
            <Grid bucket={true} container>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        <span>Flowers</span>
                    </Typography>

                    {florists.length === 0 ? (
                        <Typography variant="subtitle1">No flowers selected.</Typography>
                    ) : (
                        florists.map((florist, index) => {
                            return (
                                <div key={index}>
                                    <Typography variant="subtitle1">
                                        Florist:{' '}
                                        <strong>{(florist.Contact && florist.Contact.Name) || '(no supplier)'}</strong>
                                        {!florist.Confirmed && ' (not confirmed)'}
                                    </Typography>
                                    {florist.BookingItems.length > 0 && this.renderFlowerList(florist.BookingItems)}
                                </div>
                            );
                        })
                    )}
                </Grid>
            </Grid>
        );
    }

    renderFlowerList(flowers) {
        const { classes } = this.props;
        if (isNullOrUndefined(flowers)) return;

        return (
            <div>
                <div className={classes.flowerList}>{flowers.map(this.renderFlowerItem)}</div>
                <ul>
                    {flowers.map(value => {
                        const product = ProductConfig.productMap[value.ProductID];
                        if (!product) return null;
                        const titleObj = product.variations.find(e => e.id === value.VariationID) || product;
                        return (
                            <li key={value.ID}>
                                {Number(value.Quantity) === 0 ? '' : 'x' + Number(value.Quantity)}{' '}
                                <strong>{titleObj.internalId}</strong> : {titleObj.title}
                                {!!value.Comment ? ' | ' + value.Comment : ''}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }

    renderFlowerItem = ({ ID, ProductID, VariationID, Quantity }, i) => {
        const { classes } = this.props;
        const product = ProductConfig.productMap[ProductID];
        if (!product) return;
        return (
            <Card key={ID || i} className={classes.flowerItem} elevation={0}>
                <div style={{ backgroundImage: `url(${product.image}` }} className={classes.flowerItemImage} />
                <Typography className={classes.flowerItemName} align="center">
                    {Quantity > 1 && <span className={classes.flowerItemQty}>x{Quantity} </span>}
                    {product.title}
                </Typography>
            </Card>
        );
    };

    renderRequiredDocuments() {
        const { form, classes } = this.props;
        const requiredDocuments = getRequiredDocuments(form);

        return (
            <Grid bucket={true} xs={12}>
                <Grid item xs={12}>
                    <Typography variant={'headline'} className={cx(classes.pageTitle)}>
                        Certification Documents
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.tableData}>
                        <Table>
                            <TableHeaderRow>
                                <TableHeaderCell tiny>Status</TableHeaderCell>
                                <TableHeaderCell>Document</TableHeaderCell>
                                <TableHeaderCell>Filename</TableHeaderCell>
                            </TableHeaderRow>
                            {requiredDocuments.map((x, i) => this.renderRequiredDocument(x, i))}
                        </Table>
                    </div>
                </Grid>
            </Grid>
        );
    }

    renderRequiredDocument(requiredDocument, index) {
        const { form, classes } = this.props;

        const document = form.getField(requiredDocument.fieldName) || {
            ID: null,
            AbsoluteLink: null,
            Name: null,
            Size: 0
        };
        const arrangementForm = getSignedArrangementFormForDocument(
            form,
            requiredDocument.fieldName,
            requiredDocument.formType
        );
        const missing =
            stringIsNullOrEmpty(document.AbsoluteLink) &&
            stringIsNullOrEmpty(arrangementForm.PDF && arrangementForm.PDF.AbsoluteLink);

        if (!missing) {
            return (
                <TableRow key={index}>
                    <TableCell dataLabel="Status">
                        <div className={cx(classes.iconContainer, classes.good)}>
                            <TickCircleIcon />
                        </div>
                    </TableCell>
                    <TableCell dataLabel="Document">{requiredDocument.description}</TableCell>
                    <TableCell dataLabel="Filename">
                        <LinkButton
                            target="_blank"
                            text={document.Name || (arrangementForm.PDF && arrangementForm.PDF.Name)}
                            onClick={() => window.open(document.AbsoluteLink || arrangementForm.PDF.AbsoluteLink)}
                        />
                    </TableCell>
                </TableRow>
            );
        }

        const isCremation = form.getState('Disposal.CrematedOrBuried') === 'Cremated';
        const needsReferee = !!isCremation && !(form.getState('Certification.TypeOfBdmDeathCertificate') === 'Coroner');
        const isBad =
            !!needsReferee &&
            !form.getState('RefereeCremationCheck') &&
            ['Certification.FileCremCertificate', 'Certification.FileRefereeingDoctorForm'].includes(
                requiredDocument.fieldName
            );

        return (
            <TableRow key={index}>
                <TableCell dataLabel="Status">
                    <div className={cx(classes.iconContainer, isBad ? classes.bad : classes.warning)}>
                        {isBad ? <ExclamationCircleIcon /> : <ExclamationTriangleIcon />}
                    </div>
                </TableCell>
                <TableCell dataLabel="Document">{requiredDocument.description}</TableCell>
                <TableCell dataLabel="Filename">Not Uploaded</TableCell>
            </TableRow>
        );
    }

    backButtonFunction() {
        history.push('/mortuary');
    }

    goCheckoutFunction() {
        const { form } = this.props;
        const ID = form.getField('ID');
        const LegacyKey = form.getField('LegacyKey');
        history.push(`/mortuary/checkout/${LegacyKey}/${ID}`);
    }

    viewFuneralDetails = (id, legacyId) => {
        const path = `/funeral/${legacyId}/${id}`;
        const win = window.open(path);
        win.focus();
    };

    viewValuableItem = (evt, valuableItemId) => {
        evt.stopPropagation();
        this.setState({ valuableItemId, openValuableModal: true });
    };

    removeValuableItem = (evt, valuableItemId) => {
        evt.stopPropagation();
        this.setState({ valuableItemId, deleteValuableModal: true });
    };

    onSaveValuable = item => {
        const { Changes, Funeral, Note, ...newData } = item;
        const { form } = this.props;
        const ValuableItems = form.getState('ValuableItems') || [];
        const index = indexOf(ValuableItems, x => x.ID === item.ID);
        if (index < 0) {
            ValuableItems.push(newData);
        } else {
            Object.assign(ValuableItems[index], newData);
        }
        form.setState({ ValuableItems, Note: Note || null, ...Funeral }, 1);
        this.setState({ valuableItemId: newData.ID });
    };

    handleAcknowledgement = () => {
        this.setState({ loading: true });
        const { form } = this.props;
        acknowledgeChanges(form.getState('ID')).then(data => {
            form.setField({ ...data }, 1);
            this.setState({ loading: false });
        });
    };
    handleReleaseToCheckout = e => {
        this.setState({ loading: true });

        const { form } = this.props;
        const me = this;
        releaseToCheckout(form.getState('ID')).then(data => {
            me.props.form.setField({ ...data }, 1);
            me.setState({ loading: false });
        });
    };

    handleDeleteValuable = () => {
        this.setState({ loading: true });
        const { valuableItemId } = this.state;
        const { form } = this.props;
        const funeralID = form.getField('ID');
        const valuablesIDs = (form.getField('ValuableItems') || [])
            .map(obj => ({ ID: obj.ID }))
            .filter(obj => valuableItemId !== obj.ID);
        removeValuablesItemsAction(funeralID, valuablesIDs).then(data => {
            form.setField({ ...data }, 1);
            this.setState({ loading: false, valuableItemId: null, deleteValuableModal: false });
        });
    };

    onChangeCoffin(funeral) {
        const { form } = this.props;

        this.setState({ openCoffinModal: false });

        flattenBookingItems(funeral.Disposal, 'DisposalBookingItems');

        form.setState({
            'Disposal.DisposalBookingItems': funeral.Disposal.DisposalBookingItems
        });

        PreloadProducts(this, funeral.Disposal.DisposalBookingItems);
    }
}

const styles = ({ spacing, typography, palette, funeralHome }) => ({
    paper: {
        padding: spacing(3),
        width: '100%'
    },
    pageTitle: {
        color: palette.contentForeground[funeralHome]
    },
    coffinDetailsHeader: {
        '@media (max-width: 1280px)': {
            marginTop: 15
        }
    },
    floatRight: {
        float: 'right'
    },
    bodyPadding: {
        // padding: '1.5rem',
        '& p': {
            fontSize: '0.875rem'
        }
    },
    column: {
        padding: `${spacing(1)} 0}`
    },
    print: {
        '@media print': {
            margin: 100
        }
    },
    header: {
        fontWeight: typography.fontWeightLight,
        marginLeft: 16,
        paddingLeft: 16,
        borderLeft: '1px solid ' + palette.action.active,
        color: palette.text.primary
    },
    secondaryHeader: {
        color: palette.action.active
    },
    lightGreyHeader: {
        fontWeight: typography.fontWeightLight,
        //color: palette.custom.lightishGrey,
        borderLeft: '1px solid ' + palette.custom.lightishGrey,
        paddingLeft: 16,
        marginLeft: 16
    },
    purpleText: {
        // color: palette.action.active
        fontWeight: typography.fontWeightMedium
    },
    tableData: {
        // paddingTop: 20
    },
    smallerButton: {
        marginRight: 15,
        '& > span': {
            fontSize: 11
        }
    },
    addButtonDesktop: {
        float: 'right',
        top: -45,
        boxShadow: 'none',
        backgroundColor: palette.button.alt.backgroundColor,
        borderRadius: 18
    },
    backButtonDesktop: {
        float: 'right',
        top: -45,
        boxShadow: 'none',
        border: '1px solid',
        color: palette.button.alt.backgroundColor,
        backgroundColor: 'white',
        borderRadius: 18,
        marginRight: 15,
        '&:hover': {
            color: 'white'
        }
    },
    notesPre: {
        whiteSpace: 'pre-wrap'
    },
    photoItem: {
        backgroundColor: 'white',
        border: 'lightGrey',
        textAlign: 'center',
        lineHeight: 6
    },
    coffinDetailItem: {
        position: 'relative',
        marginBottom: 10
    },
    coffinDetailImage: {
        width: '90%',
        height: 'auto',
        border: '1px solid lightGrey'
    },
    photoItemInternal: {
        position: 'absolute',
        bottom: 0,
        backgroundColor: 'white',
        width: '90%',
        paddingLeft: 20,
        paddingTop: 5,
        paddingBottom: 5,
        textAlign: 'center',
        fontSize: 11,
        color: 'black',
        border: '1px solid lightGrey',
        borderTop: '0px'
    },
    familyPhotoGrid: {
        marginTop: 10,
        minHeight: 120
    },
    gridItemFamilyPhoto: {
        position: 'relative'
    },
    photoItemFamily: {
        position: 'relative',
        width: '90%',
        height: 'auto'
    },
    faded: { opacity: 0.5 },
    flowerList: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    flowerItem: {
        flex: '0 0 auto',
        display: 'flex',
        padding: '16px 16px 12px',
        alignItems: 'center',
        flexDirection: 'column',
        margin: '8px',
        border: `1px solid ${palette.divider}`,
        width: '200px',
        position: 'relative'
    },
    flowerItemImage: {
        width: '100%',
        height: 128,
        border: `1px solid ${palette.divider}`,
        marginBottom: 12,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    },
    flowerItemName: {
        fontSize: typography.caption.fontSize
    },
    flowerItemQty: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        background: `${palette.divider}`,
        borderRadius: '5px 0px 0px 0px',
        padding: '2px 5px',
        fontWeight: 'bold'
    },
    actions: {
        pointerEvents: 'none',
        '& > div': {
            display: 'inline-flex',
            flexWrap: 'nowrap',
            zoom: 0.875,
            '& button': {
                pointerEvents: 'auto'
            }
        }
    },
    icon: {},
    iconContainer: {
        textAlign: 'center',
        padding: '10px 0'
    },
    strikeout: {
        textDecoration: 'line-through'
    },
    warning: {
        color: palette.validation.suggested
    },
    bad: {
        color: palette.validation.error
    },
    good: {
        color: palette.validation.good
    }
});
const StyledComponent = compose(withRouter, withSnackbarMessage, withStyles(styles))(MortuaryItem);
const Tabs = [
    {
        id: 'MortuaryItem',
        label: 'Mortuary Item',
        component: StyledComponent,
        fragment: MortuaryItemFragment,
        onLoad: data => {
            if (data.Disposal) flattenBookingItems(data.Disposal, 'DisposalBookingItems');
            if (data.Florists) data.Florists.forEach(florist => flattenBookingItems(florist, 'BookingItems'));
        },
        formatSaveData: (saveData, state, original) => {
            if (isNullOrUndefined(saveData.ReadyForMortuary)) {
                saveData.ReadyForMortuary = !state.ReadyForMortuary; // always send something, the server will override
            }
        }
    }
];

class MortuaryItemView extends Component {
    render() {
        return (
            <DataFormView
                tabs={Tabs}
                createNew={false}
                createNewFunc={null}
                objectType="Funeral"
                itemId={this.props.match.params.id}
                name="MortuaryItem"
                context={this}
                readOnly={false}
            />
        );
    }
}

export default withErrorBoundary(compose(withRouter, withStyles(styles))(MortuaryItemView), {
    fallback: ErrorFallback
});
